import { Suspense, useEffect } from 'react'
import { RouterProvider } from 'react-router-dom'
import { RouteFallback } from './routes/RouteFallback'
import { router } from './routes/router'
import { LocaleProvider } from './i18n/locale'
import { fetchHotpayPricing } from './lib/api/hotpay'

export default function App() {
  useEffect(() => {
    void fetchHotpayPricing().catch(() => {})
  }, [])

  return (
    <LocaleProvider>
      <Suspense fallback={<RouteFallback />}>
        <RouterProvider router={router} />
      </Suspense>
    </LocaleProvider>
  )
}
